export const environment = {
  URL_LANDING: '',
  production: false,
  profile: 'hmg',
  GOOGLE_ID: 'GTM-NZNQJ5M6',
  URL_OMNI_AUTH: 'https://auth-cliente.hmg-omnicfi.us-east-1.omniaws.io',
  URL_OMNI_API:'https://api.hmg-omnicfi.us-east-1.omniaws.io/portal-negociacao',
  URL_OMNI_MEU_FINANCIAMENTO: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/meufinanciamento/api',
};
